import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteProductClassesList } from './normalize';

export const fetchQuoteProductClassesList = createProvider(api.fetchQuoteProductClassesList)
  .andThen((res) => normalizeQuoteProductClassesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
